<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let question;
    export let actualQuestionNo;
    let selectedAnswer;

    function handle(event) {
        dispatch('answered', {
			selectedAnswer
        });
        selectedAnswer = undefined;
	}

</script>

<h2>Frage {actualQuestionNo}</h2>

<form on:submit|preventDefault={handle}>

    <div class="question">
        <p>{@html question.text}</p>
        {#each question.answers as answer}
            <div class="form-check">
                <label for="{answer.ID}" class="form-check-label">
                <input class="form-check-input" type="radio" bind:group={selectedAnswer} id={answer.ID} value={answer.ID}/>
                {@html answer.Text}
                </label>
            </div>
        {/each}
    </div>

    <button disabled={selectedAnswer === undefined}>Antworten</button>
</form>